// extracted by mini-css-extract-plugin
export default {"sticky-footer":"sticky-footer--1sAJw","top-bar":"top-bar--2Ky5d"};
    if(module.hot) {
      // 1747648152385
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  